import { RunwayModelsResponse } from '@/types';

export const UPDATE_ORG_USERS_VCS_USER_DATA = 'TRY_UPDATE_ORG_USERS_VCS_USER_DATA';

export interface TryUpdateOrgUsersVCSUserData {
    type: typeof UPDATE_ORG_USERS_VCS_USER_DATA;
    payload: RunwayModelsResponse['orgUsersVCSUserData'];
}

export const updateOrgUsersVCSUserData = (
    payload: RunwayModelsResponse['orgUsersVCSUserData'],
): TryUpdateOrgUsersVCSUserData => {
    return {
        type: UPDATE_ORG_USERS_VCS_USER_DATA,
        payload: payload,
    };
};
